import { render, staticRenderFns } from "./MiningGuideForm.vue?vue&type=template&id=78c2a2ae&scoped=true&"
import script from "./MiningGuideForm.vue?vue&type=script&lang=js&"
export * from "./MiningGuideForm.vue?vue&type=script&lang=js&"
import style0 from "./MiningGuideForm.vue?vue&type=style&index=0&id=78c2a2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c2a2ae",
  null
  
)

export default component.exports